




























import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IItem, instanceOfIDrawableItem } from "../../../../../../domain/document/items";
import { Point, Size, Rectangle } from "../../../../../../domain/drawing";
import OptionDropDownSelector from "../../../../../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { StandardOption } from "../../../../../system/selectors/mixins";
import { EditingDocument } from "../../../../../document/editor";
import {
  DocumentStructureEditableMixin,
  CommonComponentsAccessibleMixin,
} from "../../../../../document/editor/mixins";
import IdentifierViewer from "../../../../../document/editor/propertyEditors/IdentifierViewer.vue";
import GeometryViewer from "../../../../../document/editor/propertyEditors/GeometryViewer.vue";

@Component({
  components: {
    IdentifierViewer,
    GeometryViewer,
    OptionDropDownSelector,
  }
})
export default class ObjectSelector extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin, CommonComponentsAccessibleMixin) {
  editingSource: EditingDocument;

  @Prop()
  isDebugging: boolean;

  data(): any {
    return {
      isSelecting: false,
      selectedOption: null,
      filter: new Rectangle(new Point(0, 0), new Size(0, 0)),
    };
  }
  isSelecting: boolean;
  selectedOption: number;
  filter: Rectangle;

  mounted(): void {
    this.resetFilter();
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: EditingDocument, oldValue: EditingDocument): void {
    this.resetFilter();
  }

  private resetFilter(): void {
    this.filter = new Rectangle(
      new Point(0, 0),
      this.currentSection ? this.currentSection.size : new Size(0, 0)
    );
  }

  destroyed(): void {
    // destroyedを契機に処理するとき、あるはずのコンポーネントがundefinedになっているケースがあるので注意が必要
    this.stopSelectRectangle();
  }

  get shouldSelectRectangle(): boolean {
    return this.isDebugging
        && this.isSelecting;
  }

  @Watch("shouldSelectRectangle")
  onShouldSelectRectangleChanged(newValue: boolean, oldValue: boolean): void {
    (newValue ? this.startSelectRectangle : this.stopSelectRectangle)();
  }

  async startSelectRectangle(): Promise<void> {
    console.debug("start object selection.");
    const result = await this.commonComponents.editors.page.selectRectangle(this);
    if (result) {
      this.filter = result;
      this.startSelectRectangle();
    }
  }

  stopSelectRectangle(): void {
    console.debug("stop object selection.");
    this.commonComponents.editors.page.cancel(this);
  }

  get filterX(): number {
    return this.filter
      ? this.filter.x
      : 0;
  }

  set filterX(value: number) {
    this.filter = new Rectangle(
      new Point(value, this.filter.y),
      this.filter.size
    );
  }

  get filterY(): number {
    return this.filter
      ? this.filter.y
      : 0;
  }

  set filterY(value: number) {
    this.filter = new Rectangle(
      new Point(this.filter.x, value),
      this.filter.size
    );
  }

  get filterWidth(): number {
    return this.filter
      ? this.filter.width
      : 0;
  }

  set filterWidth(value: number) {
    this.filter = new Rectangle(
      this.filter.topLeft,
      new Size(value, this.filter.height)
    );
  }

  get filterHeight(): number {
    return this.filter
      ? this.filter.height
      : 0;
  }

  set filterHeight(value: number) {
    this.filter = new Rectangle(
      this.filter.topLeft,
      new Size(this.filter.width, value)
    );
  }

  get options(): StandardOption<number>[] {
    return Enumerable.from(this.currentSectionItems)
      .where(i => !!i && this.isValidOption(i))
      .select(i => new StandardOption<number>(this.toOptionLabel(i), i.privateId))
      .toArray();
  }

  isValidOption(source: IItem): boolean {
    return !instanceOfIDrawableItem(source)
        || this.filter.overlaps(source.geometry.rectangle);
  }

  isValidPosition(filter: number, from: number, to: number): boolean {
    try {
      return (!filter || ((from <= filter) && (filter <= to)));
    } catch {
      return true;
    }
  }

  toOptionLabel(source: IItem): string {
    return this.toGeometryLabel(source)
      + "[" + source.typeKey + "]"
      + "[" + source.privateId + "]"
      + "[" + source.id + "]"
      + "[" + (source as any).name + "]";
  }

  private toGeometryLabel(source: IItem): string {
    return instanceOfIDrawableItem(source)
      ? "(" + source.geometry.rectangle.x + "," + source.geometry.rectangle.y + ")" + source.geometry.rectangle.width + "x" + source.geometry.rectangle.height
      : "";
  }

  select(): void {
    this.isSelecting = true;
  }

  async apply(): Promise<void> {
    this.editingSource.updateFocusedItem(this.currentSection.itemSetId, this.selectedItem);
    this.isSelecting = false;
  }

  cancel(): void {
    this.isSelecting = false;
  }

  get selectedItem(): IItem {
    return this.isSelecting
      ? this.items[this.selectedOption]
      : this.source;
  }

  get source(): any {
    return this.isSelecting
      ? this.selectedItem
      : this.readPropertyOrDefault(s => s.lastFocusedItem, null);
  }

  get isItemSelected(): boolean {
    return !!this.source;
  }
}
